export default __webpack_public_path__ + "static/media/rr.6e7005fc.jpg";